<template>
	<div v-if="loaded">
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<md-field>
					<label>លេខកូដកញ្ចប់</label>
					<md-input type="text" v-model="package.tracking" disabled="disabled"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25">
				<md-field>
					<label>ប្រភេទកញ្ចប់</label>
					<md-input type="text" v-model="package.package_type" disabled="disabled"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25">
				<md-field>
					<label>ទីតាំង</label>
					<md-input type="text" v-model="package.location" disabled="disabled">
					</md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<label>តម្លៃឥវ៉ាន់ *</label>
					<md-input type="number" v-model="package.price"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<label>ប្រភេទប្រាក់ *</label>
					<md-select placeholder="ប្រភេទប្រាក់ *" v-model="package.price_currency">
						<md-option value="usd">ដុល្លា</md-option>
						<md-option value="khr">រៀល</md-option>
					</md-select>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<label>ថ្លៃដឹកជញ្ជូន *</label>
					<md-input type="number" v-model="package.fee"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<label>អ្នកបង់ថ្លៃដឹកជញ្ជូន *</label>
					<md-select placeholder="អ្នកបង់ថ្លៃដឹកជញ្ជូន *" v-model="package.fee_responsible">
						<md-option value="rcv">អ្នកទទួល</md-option>
						<md-option value="snd">អ្នកផ្ញើ</md-option>
					</md-select>
				</md-field>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<label>លេខទូរស័ព្ទអ្នកទទួល *</label>
					<md-input type="text" v-model="package.receiver_phone"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-60">
				<md-field>
					<label>កំណត់ចំណាំផ្សេងៗសម្រាប់ក្រុមហ៊ុន</label>
					<md-input type="text" v-model="package.package_note"></md-input>
				</md-field>
			</div>
		</div>

		<div class="md-layout-item md-size-100 text-right">
			<md-button class="md-raised md-primary" @click="updatePackage()">កែប្រែ</md-button>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon'
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.getPackage();

		},
		data() {
			return {
				loaded: false,
				package: {
					type: "",
					locationArray: "",
					packageTypeArray: "",
					location_id: "",
					location: "",
					price: "",
					price_currency: "usd",
					fee: "",
					fee_currency: "usd",
					fee_responsible: "snd",
					client_id: "",
					client_name: "",
					client_phone: "",
					// sender_phone: "",
					receiver_phone: "",
					package_note: ""
				},
				isValid: false

			}
		},
		watch: {
			'package.price_currency' : function(val) {
				if(val == "khr" && this.package.fee_currency == "usd") {
					this.package.fee = this.package.fee * 4000;
					this.package.fee_currency = "khr";
				}

				if(val == "usd" && this.package.fee_currency == "khr") {
					this.package.fee = this.package.fee / 4000;
					this.package.fee_currency = "usd";
				}
			},
			'package.price': function (val) {
				if (parseInt(val) > 1000 && this.package.price_currency == "usd") {
					this.package.price_currency = "khr";
					this.package.fee = this.package.fee * 4000;
					this.package.fee_currency = "khr";
				} else if (parseInt(val) < 1000 & this.package.price_currency == "khr") {
					this.package.price_currency = "usd";
					this.package.fee = this.package.fee / 4000;
					this.package.fee_currency = "usd";
				}
			},
		},
		methods: {
			getPackage(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/package/get/" + this.$route.params.hash_id).then(data => {
					this.package = data.body.data
					// console.log(data.body.data)
					this.loaded = true
				})
			},
			updatePackage() {

				if (this.checkValidation()) {
					this.$http.post(this.config.api + "/admin/package/update", {
						package_hash_id: this.$route.params.hash_id,
						package: this.package
					}).then(res => {
						if (res.body.status == 'success') {
							this.tabName = 'first'
							this.$notification.notify({
								message: "បានកែប្រែដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.$router.push('/packages/detail/' + this.$route.params.hash_id);
						}
					})
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'error',
						type: 'danger'
					})
				}
			},
			checkValidation() {
				if (String(this.package.fee).length > 0 && String(this.package.fee_currency).length > 0 &&
					String(this.package.price).length > 0 && String(this.package.price_currency).length > 0 && String(this.package.fee_responsible).length > 0 &&
					String(this.package.receiver_phone).length > 0) {
					return true;
				} else {
					return false;
				}
			}
		}
	}
</script>
<style>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50% !important;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Packages/Edit.vue